import React, { useEffect, useState } from 'react';
import { Alert } from '../../../components/visual/Alert/Alert';
import useMessages from '../../../utils/useMessages';

export const Messages = () => {
  const messages = useMessages();

  /**
   * @type {[ import('../../../store/reducers/notificationsReducer').TNotificationItem[], Function ]}
   */
  const [onScreenMessages, setOnScreenMessages] = useState([]);

  // copy messages into own list
  useEffect(() => {
    setOnScreenMessages(messages.messages);
  }, [messages.messages]);

  const renderMessage = () => {
    return onScreenMessages.map(msg => (<Alert
      key={msg.message + msg.type}
      type={msg.type}
      message={msg.message}
      onClose={() => messages.closeMessage(msg.message, msg.type)} />));
  };

  return <>
    {renderMessage()}
  </>;
}
